import { useState, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
// handlers
import user from "src/components/UI/Shared/user";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

type AuthGuardProps = {
  children: ReactNode;
};
const AuthGuard = ({ children }: AuthGuardProps) => {
  const dispatch = useDispatch();
  const previousNavigation = useSelector(
    (state: any) => state.app.previousNavigation
  );

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );
  const current_user = user.getCurrentLoggedIn();
  if (current_user === "guest") {
    if (previousNavigation === "/Geo") {
      dispatch(appActions.setPreviousNavigation("/"));
      dispatch(
        appActions.setSearchString({
          menu1: "",
          menu2: "",
          menu3: "",
          menu4: "",
          menu5: "",
          menu6: "",
        })
      );
      return <Navigate to="/" />;
    }
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
      dispatch(appActions.setPreviousNavigation(pathname));
    }
    return <Navigate to="/identity/login" />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} />;
  }
  return <> {children} </>;
};
export default AuthGuard;
